import { render, staticRenderFns } from "./prod-list.vue?vue&type=template&id=05f1dcde&scoped=true"
import script from "./prod-list.vue?vue&type=script&lang=js"
export * from "./prod-list.vue?vue&type=script&lang=js"
import style0 from "./prod-list.vue?vue&type=style&index=0&id=05f1dcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f1dcde",
  null
  
)

export default component.exports